import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { Images } from '../../style';
import { NotFoundSvg } from '../../vp-ui';
import { StyledStack } from './styles';

function NotFound() {
  return (
    <StyledStack>
      <NotFoundSvg />
      <Stack gap="15px" justifyContent="center" alignItems="center">
        <Typography sx={{ fontSize: 40, fontWeight: 900 }}>Page Not Found</Typography>
        <Typography variant="caption">
          {`We've searched everywhere but couldn't find what you're looking for!`}
          <br />
          This page is either unavailable or does not exist. Check back at another time.
        </Typography>

        <Typography variant="subtitle2" sx={{ mx: 'auto' }}>
          Powered by{' '}
          <Box component="img" src={Images.logo} sx={{ width: '70px', height: 'auto' }} />
        </Typography>
      </Stack>
    </StyledStack>
  );
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/containers/NotFound/index.jsx